function changeDesktopLayout(n) {
  const prodGrid = document.querySelector('ul#product-grid');
  const toRemove = [];
  for (let i = 2; i <= 4; i++) {
    if (i != n) {
      toRemove.push(`grid--${i}-col-desktop`);
    }
  }
  // for (let i = 1; i <= 2; i++) {
  //   toRemove.push(`grid--${i}-col-tablet`);
  //   toRemove.push(`grid--${i}-col-tablet-down`);
  // }
  layoutBtns = document.querySelector('#grid-layout-switch ul').querySelectorAll('li');
  layoutBtns.forEach((button) => {
    if (Number(button.querySelector('span').innerHTML) == n) {
      button.classList.add('layout-selected');
    } else {
      button.classList.remove('layout-selected');
    }
  });
  prodGrid.classList.remove(...toRemove);
  prodGrid.classList.add(`grid--${n}-col-desktop`);
  // prodGrid.classList.add(`grid--${n}-col-tablet-down`);
}

// Columns for mobile layout {29/05/25}
const productGrid = document.querySelector('ul#product-grid');
const to_remove = [];
for (let i = 1; i <= 2; i++) {
  to_remove.push(`grid--${i}-col-tablet`);
  to_remove.push(`grid--${i}-col-tablet-down`);
}
productGrid.classList.remove(...to_remove);
productGrid.classList.add('grid--2-col-tablet-down');

if (window.innerWidth < 990) {
  document.getElementById('grid-layout-switch').style.display = 'none';
} else {
  document.getElementById('grid-layout-switch').style.display = 'flex';
}

const changeLayoutBtns = document.querySelector('#grid-layout-switch ul').querySelectorAll('li');
changeLayoutBtns.forEach((layoutBtn) => {
  console.log(layoutBtn.innerHTML);
  let spanEleNum = Number(layoutBtn.querySelector('span').innerHTML);
  layoutBtn.addEventListener('click', function() {
    changeDesktopLayout(spanEleNum);
  });
});